export type BanCategory = "cheat" | "team_up" | "insultes_admins";

export function banReason(): string {
  return "Ban Automatique | Blacklist Events WLS | Ban dans un tournoi";
}

export function discordIds(values: Array<string | undefined>): string[] {
  const output = new Set<string>();
  for (const value of values) {
    const normalized = value?.trim();
    if (normalized && /^\d{15,21}$/.test(normalized)) output.add(normalized);
  }
  return [...output];
}

export function discordIdsText(values: Array<string | undefined>): string {
  const ids = discordIds(values);
  return ids.length > 0 ? `${ids.join("\n")}\n` : "";
}

export function exportFilename(label: string): string {
  const slug = label.normalize("NFKD").replace(/\p{M}/gu, "").toLocaleLowerCase("fr")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 80);
  return `${slug || "tournoi"}-discord-ids.txt`;
}

export async function copyText(value: string): Promise<void> {
  await navigator.clipboard.writeText(value);
}

export function downloadDiscordIds(label: string, values: Array<string | undefined>): number {
  const ids = discordIds(values);
  if (ids.length === 0) return 0;
  const url = URL.createObjectURL(new Blob([`${ids.join("\n")}\n`], { type: "text/plain;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = exportFilename(label);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return ids.length;
}
